const normalizeText = value => String(value ?? '').trim().replace(/\s+/g, ' ').toLowerCase();

const phoneDigits = value => {
    const digits = String(value ?? '').replace(/[()\s.+-]/g, '');
    if (!/^\d+$/.test(digits)) return '';
    // Paua stores both local and international New Zealand phone numbers.
    return digits.startsWith('64') && digits.length >= 10 ? `0${digits.slice(2)}` : digits;
};

const searchFields = [
    'full_name', 'first_name', 'middle_name', 'last_name', 'known_as_name',
    'email', 'nhi', 'client_id', 'person_id', 'tk_person_id',
];
const phoneFields = ['mobile_phone', 'home_phone', 'work_phone', 'phone'];

/** Match identity and contact details without searching clinical notes or metadata. */
export const createPauaClientMatcher = query => {
    const needle = normalizeText(query);
    const digits = phoneDigits(query);
    const matchesClient = (client = {}) => {
        if (!needle) return true;
        const names = [
            [client.first_name, client.last_name],
            [client.first_name, client.middle_name, client.last_name],
        ].map(parts => parts.filter(Boolean).join(' '));
        const dateOfBirth = String(client.date_of_birth ?? '').slice(0, 10);
        const birthDates = /^\d{4}-\d{2}-\d{2}$/.test(dateOfBirth)
            ? [dateOfBirth, dateOfBirth.split('-').reverse().join('/')]
            : [];
        const phones = [
            ...phoneFields.map(field => client[field]),
            ...(client.phone_numbers || []).map(phone => phone.phone_number),
        ];
        const values = [...searchFields.map(field => client[field]), ...names, ...birthDates, ...phones];
        return values.some(value => normalizeText(value).includes(needle))
            || (!!digits && phones.some(phone => phoneDigits(phone).includes(digits)))
            || (client.search_identities || []).some(matchesClient);
    };
    return matchesClient;
};

/** Keep table column searching, and also match identity details hidden from the table. */
export const filterPauaClientTable = (rows, query, columns, getCellValue) => {
    const matchesClient = createPauaClientMatcher(query);
    const needle = normalizeText(query);
    return rows.filter(row => matchesClient(row)
        || columns.some(column => normalizeText(getCellValue(column, row)).includes(needle)));
};
